const through = require('through')

const sameOrigin = require('airship/modules/request2/utils/same-origin')
const normalizeHeaders = require('airship/modules/request2/utils/normalize-headers')
const cookie = require('airship/utils/cookie')

module.exports = addCSRF

function addCSRF() {
  return through(function(reqData) {
    // First, check to see if the CSRF token is required.
    const csrfSafeMethods = ['GET', 'HEAD', 'OPTIONS', 'TRACE']
    const methodSeen = reqData.method || 'get'

    if (csrfSafeMethods.includes(methodSeen.toUpperCase())) {
      this.queue(reqData)
      return
    }

    // Ensure the properties we need are present.
    reqData.headers = normalizeHeaders(reqData.headers || {})

    // If we're here, the token may be necessary.
    if (!reqData.headers.hasOwnProperty('x-csrftoken') && sameOrigin(reqData)) {
      reqData.headers['x-csrftoken'] = cookie('csrftoken')
    }

    this.queue(reqData)
  })
}
